import { combineReducers } from 'redux';

import {
    LOAD_DEBTORS_REQUEST,
    LOAD_DEBTORS_SUCCESS,
    LOAD_DEBTORS_ERROR,
    LOAD_DEBTOR_REQUEST,
    LOAD_DEBTOR_SUCCESS,
    LOAD_DEBTOR_ERROR,
    FETCHED_DEBT_ACTIONS,
    REQUESTING_DEBT_ACTIONS,
    FETCH_DEBT_ACTIONS_ERROR,
    INACTIVE_DEBT_REQUEST,
    INACTIVE_DEBT_SUCCESS,
    FINISH_DEBT_REQUEST,
    FINISH_DEBT_SUCCESS,
    INACTIVE_DEBT_ERROR,
    FINISH_DEBT_ERROR,
    ACTIVATE_DEBT_REQUEST,
    ACTIVATE_DEBT_SUCCESS,
    ACTIVATE_DEBT_ERROR,
} from 'src/modules/debtors/actions/debtors.actions';

import { AUTH_LOGOUT } from 'src/modules/auth/actions/authentication.action';

const data = (state = {}, action) => {
    switch (action.type) {
        case LOAD_DEBTORS_SUCCESS:
            return action.payload;
        case AUTH_LOGOUT:
            return {};
        default:
            return state;
    }
};

const isLoading = (state = false, action) => {
    switch (action.type) {
        case LOAD_DEBTORS_REQUEST:
            return true;
        case LOAD_DEBTORS_SUCCESS:
        case LOAD_DEBTORS_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const debtorInformation = (state = null, action) => {
    switch (action.type) {
        case LOAD_DEBTOR_SUCCESS:
            return action.payload;
        case INACTIVE_DEBT_SUCCESS:
        case FINISH_DEBT_SUCCESS:
        case ACTIVATE_DEBT_SUCCESS:
            return {
                ...state,
                debts: state.debts.map(el => ((el.pk_debt === action.payload.pk_debt) ? action.payload : el)),
            };
        case LOAD_DEBTOR_ERROR:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const loadingDebtActions = (state = false, action) => {
    switch (action.type) {
        case REQUESTING_DEBT_ACTIONS:
            return true;
        case FETCHED_DEBT_ACTIONS:
        case FETCH_DEBT_ACTIONS_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const debtActions = (state = { system: {}, operator: {} }, action) => {
    switch (action.type) {
        case FETCHED_DEBT_ACTIONS:
            return {
                system: action.payload.system ? action.payload.system : state.system,
                operator: action.payload.operator ? action.payload.operator : state.operator,
            };
        case AUTH_LOGOUT:
            return {
                system: {},
                operator: {},
            };
        default:
            return state;
    }
};

const loadingDebtor = (state = false, action) => {
    switch (action.type) {
        case LOAD_DEBTOR_REQUEST:
            return true;
        case LOAD_DEBTOR_SUCCESS:
        case LOAD_DEBTOR_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const loadingInactiveDebt = (state = false, action) => {
    switch (action.type) {
        case INACTIVE_DEBT_REQUEST:
            return true;
        case INACTIVE_DEBT_SUCCESS:
        case INACTIVE_DEBT_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const loadingActivateDebt = (state = false, action) => {
    switch (action.type) {
        case ACTIVATE_DEBT_REQUEST:
            return true;
        case ACTIVATE_DEBT_SUCCESS:
        case ACTIVATE_DEBT_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};


const loadingFinishDebt = (state = false, action) => {
    switch (action.type) {
        case FINISH_DEBT_REQUEST:
            return true;
        case FINISH_DEBT_SUCCESS:
        case FINISH_DEBT_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    data,
    isLoading,
    debtorInformation,
    loadingDebtor,
    loadingDebtActions,
    loadingActivateDebt,
    debtActions,
    loadingInactiveDebt,
    loadingFinishDebt,
});
